import { NumberParam, useQueryParam, withDefault } from 'use-query-params'
import { Penalty } from '~/shared/api'
import { DrawerComponent } from '~/shared/ui/Drawer'
import { SCROLLABLE_LIST_PAGE_KEY } from '~/shared/ui/ScrollableList'
import { Content } from './Content'

type FineListDrawerProps = {
  isShow: boolean
  onClose: () => void
  onPenaltyClick: (penalty: Penalty) => void
}

export function ListPenaltyDrawer({
  isShow,
  onClose,
  onPenaltyClick,
}: FineListDrawerProps) {
  const [, setPageQuery] = useQueryParam(
    SCROLLABLE_LIST_PAGE_KEY,
    withDefault(NumberParam, 1),
  )

  const handleClose = () => {
    setPageQuery(undefined)
    onClose()
  }

  return (
    <DrawerComponent
      isShow={isShow}
      onCancel={handleClose}
      contentProps={{
        className: 'ion-content-scroll-host',
        style: { height: '90vh' },
      }}
    >
      <Content onPenaltyClick={onPenaltyClick} />
    </DrawerComponent>
  )
}
